import React, { useEffect, useRef, useState } from "react";
import { FormattedMessage, useIntl } from 'react-intl';
import { Helmet } from'react-helmet';
import classes from "./eventCustomer.module.css";
import { useEventCustomer } from "./useEventCustomer";
import ErrorView from "../../components/ErrorView/errorView";
import { Button, Checkbox, Col, DatePicker, Divider, Form, Input, message, Row, Select, Spin, Upload } from "antd";
import { SearchOutlined } from '@ant-design/icons';

const EventCustomer = props => {

    const { formatMessage } = useIntl();

    const contentRef = useRef();
    const [bigclientWidth, setBigClientWidth] = useState(window.innerWidth);

    const {
        loading,
        errorMessage,
        form,
        warrantyGroup,
        allSelectOptions,
        allSelectValues,
        handleChangeSelect,
        fileList,
        contextHolder,
        handleRemoveFile,
        handleBeforeUpload,
        handleFormatFile,
        handleOnChangeFile,
        handleChangeDatePicker,
        handleSubmitForm,
        handleGetRules,
        formToken,
        searchValue,
        setSearchValue
    } = useEventCustomer();

    useEffect(()=>{
        if(warrantyGroup?.length) {
            window?.parent?.postMessage({getCurrentWidth: true}, "*");
        }
    }, [warrantyGroup])

    useEffect(()=>{
        window.addEventListener('message', (event) => {
            // 处理消息
            if (event.data?.windowWidth) {
                setBigClientWidth(parseFloat(event.data?.windowWidth));
            }
        });

        if (contentRef?.current) {
            const height = contentRef?.current.clientHeight;
            const final_height = !height || height < 700 ? 700 : height;
            window?.parent?.postMessage({eventIframeHeight: final_height}, "*");
        }
      
        const resizeObserver = new ResizeObserver(entries => {
            for (const entry of entries) {
              if (entry.target === contentRef.current) {
                const height = contentRef?.current.clientHeight;
                const final_height = !height || height < 700 ? 700 : height;
                window?.parent?.postMessage({eventIframeHeight: final_height}, "*");
              }
            }
        })
      
        if (contentRef?.current) {
            resizeObserver.observe(contentRef?.current)
        }
      
        return () => {
            if (contentRef?.current) {
              resizeObserver.unobserve(contentRef?.current)
            }
        }
    }, [])

    return <>
        <Helmet >
            <title>Event Form</title>
            <meta name="description" content="Event Form" />
            <link rel="icon" href="https://www.gaxas.ai/api/media/file/favicon-1.svg"/>
        </Helmet>
        <Spin spinning={loading}>
            {
                errorMessage ? <div ref={contentRef} className={classes.errorRoot}>
                    {errorMessage}
                </div> : <div ref={contentRef}>
                    <h1>{formToken.event_name}</h1>
                    <Form className={`${classes.root} ${bigclientWidth <= 768 ? classes.min_root : ''}`} form={form} onFinish={handleSubmitForm}>
                        {contextHolder}
                        <Row gutter={24}>
                            {
                                warrantyGroup?.map((w_group, w_ind)=>{
                                    return <Col span={24} key={w_ind}>
                                        <div className={classes.group} key={w_group?.group_name+w_ind}>
                                            <div className={classes.group_name}>
                                                {w_group?.group_name}
                                            </div>
                                            {
                                                w_group?.fields?.map((formField, f_ind)=>{
                                                    return formField.display !== true ? null : <div className={classes.fieldBox} key={formField.field_code+f_ind}
                                                        style={(formField.options?.length && !allSelectOptions[formField.field_code]?.length) ? {
                                                            width: 0,
                                                            height: 0,
                                                            opacity: 0,
                                                            overflow: "hidden"
                                                        } : {}}
                                                    >
                                                        {
                                                            formField.comment ? <div className={classes.fieldComment}>
                                                                {formField.comment}
                                                            </div> : null
                                                        }
                                                            {
                                                                formField.field_type === 'file' ? <Upload
                                                                    onRemove={handleRemoveFile}
                                                                    beforeUpload={handleBeforeUpload}
                                                                    customRequest={handleFormatFile}
                                                                    onChange={handleOnChangeFile}
                                                                    fileList={fileList}
                                                                    maxCount={1}
                                                                    accept=".png,.gif,.jpg,.jpeg,.pdf"
                                                                >
                                                                    <div className={classes.uploadButton}>
                                                                        <FormattedMessage id={'form.uploadBtn'} defaultMessage={'UPLOAD'} />
                                                                        {formField.is_required ? '*' : ''}
                                                                    </div>
                                                                    <div className={classes.uploadTips}>
                                                                        <FormattedMessage id={'form.uploadSizeTips'} defaultMessage={'Files must be less than 5MB.'} />
                                                                        <br />
                                                                        <FormattedMessage id={'form.uploadTypeTips'} defaultMessage={'Allowed file types: png gif jpg jpeg pdf.'} />
                                                                    </div>
                                                                </Upload> :
                                                                formField.field_type === 'date' ? <Form.Item 
                                                                    name={formField.field_code}
                                                                    rules={handleGetRules(formField.is_required, formField.validate_rule, formField.field_name)}
                                                                >
                                                                    <DatePicker
                                                                        placeholder={`${formField.field_name} ${formField.is_required ? '*' : ''}`}
                                                                        onChange={handleChangeDatePicker}
                                                                    />
                                                                </Form.Item> :
                                                                formField.field_type === 'checkbox' ? <Form.Item 
                                                                    name={formField.field_code}
                                                                    rules={!formField.is_required ? [] : [{
                                                                        validator: (_, value) =>
                                                                        value ? Promise.resolve() : Promise.reject(new Error(formatMessage({
                                                                                id: "form.is_requiredAccept", 
                                                                                defaultMessage: "You must accept this to proceed."
                                                                            }, {
                                                                                name: formField.field_code
                                                                            }))),
                                                                        }
                                                                    ]}
                                                                    valuePropName="checked"
                                                                >
                                                                    <Checkbox>
                                                                        {
                                                                            formField.link ? <a href={formField.link} target="_blank" rel="noreferrer" style={{ whiteSpace: 'pre-wrap' }}>
                                                                                {`${formField.field_name}${formField.is_required ? '\u00A0*' : ''}`}
                                                                            </a> : <p style={{ whiteSpace: 'pre-wrap' }}>
                                                                                {`${formField.field_name}${formField.is_required ? '\u00A0*' : ''}`}
                                                                            </p>
                                                                        }
                                                                    </Checkbox>
                                                                </Form.Item> : 
                                                                formField.field_type === 'text' ? <Form.Item 
                                                                    name={formField.field_code}
                                                                    rules={handleGetRules(formField.is_required, formField.validate_rule, formField.field_name)}
                                                                >
                                                                    <Input 
                                                                        placeholder={`${formField.field_name} ${formField.is_required ? '*' : ''}`}
                                                                    />
                                                                </Form.Item> :
                                                                formField.field_type === 'single_select' ? <Form.Item 
                                                                    name={formField.field_code}
                                                                    rules={handleGetRules(formField.is_required, formField.validate_rule, formField.field_name)}
                                                                >
                                                                    <Select 
                                                                        placeholder={`${formField.field_name} ${formField.is_required ? '*' : ''}`}
                                                                        value={allSelectValues[formField.field_code]}
                                                                        options={searchValue[formField.field_code]
                                                                            ? allSelectOptions[formField.field_code]?.filter(all_sel =>
                                                                                all_sel.label.toLowerCase().includes(searchValue[formField.field_code].toLowerCase())
                                                                            )
                                                                            : allSelectOptions[formField.field_code]
                                                                        }
                                                                        onChange={(val)=>{handleChangeSelect(formField.field_code, val)}}
                                                                        dropdownRender={(menu)=>(<div>
                                                                            <div style={{ padding: 8 }}>
                                                                                <Input
                                                                                    placeholder="Search..."
                                                                                    value={searchValue[formField.field_code]}
                                                                                    onChange={e => setSearchValue(preData=>({
                                                                                        ...preData,
                                                                                        [formField.field_code]: e.target.value
                                                                                    }))}
                                                                                    onKeyDown={e => e.stopPropagation()}
                                                                                    suffix={<SearchOutlined />}
                                                                                />
                                                                            </div>
                                                                            <Divider style={{ margin: '8px 0' }} />
                                                                            {menu}
                                                                        </div>)}
                                                                    />
                                                                </Form.Item>
                                                                : null
                                                            }
                                                    </div>
                                                })
                                            }
                                        </div>
                                        {
                                            w_ind === warrantyGroup?.length-1 ? <div className={classes.actions}>
                                                <Button className={classes.submitButton} htmlType="submit" >
                                                    {/* <FormattedMessage id="eventForm.submitButton" defaultMessage={"Register"} /> */}
                                                    Register 註冊
                                                </Button>
                                            </div> : null
                                        }
                                    </Col>
                                })
                            }
                        </Row>
                    </Form>
                </div>
            }
        </Spin>
    </>
}

export default EventCustomer